import { useRef, useState, useEffect } from "react";
import axios from '../api/axios';
import { Link, useNavigate, useParams } from "react-router-dom";

// const USER_REGEX = /^[A-z][A-z0-9-_]{4,50}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{5,24}$/;
const TOKEN_REGEX = /^[A-Z0-9]{64}$/;
const CHANGE_PASSWORD_URL = '/changePassword';

const Register = () => {

    const { requestId, requestToken } = useParams();

    const navigate = useNavigate();

    const errRef = useRef();

    const [pwd, setPwd] = useState('');
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);

    const [matchPwd, setMatchPwd] = useState('');
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [showPasswords, setShowPasswords] = useState(false);

    useEffect(() => {
        console.log(`requestId: ${requestId} requestToken: ${requestToken}`);
        if (!TOKEN_REGEX.test(requestToken)) {
            navigate('/login', { replace: true });
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setValidPwd(PWD_REGEX.test(pwd));
        setValidMatch((pwd === matchPwd));
    }, [pwd, matchPwd])

    useEffect(() => {
        setErrMsg('');
    }, [pwd, matchPwd])

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if button enabled with JS hack
        const test = PWD_REGEX.test(pwd);
        if (!test) {
            setErrMsg("Invalid Entry");
            return;
        }
        try {
            const response = await axios.post(CHANGE_PASSWORD_URL,
                JSON.stringify({
                    password: pwd,
                    requestId,
                    requestToken
                }),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            // TODO: remove console.logs before deployment
            console.log(JSON.stringify(response?.data));
            //console.log(JSON.stringify(response))
            setSuccess(true);
        } catch (err) {
            console.log(err);
            console.log(`err.response?.status: ${err.response?.status}`);
            if ((!err?.response) || (err.response?.status === 500)) {
                setErrMsg('Our apologies, but we\'re experiencing technical difficulties.');
            } else if (err.response?.status === 401) {
                setErrMsg('We were not able to change your password, probably because the link to reset your password was expired. You can request a new link to try again.');
            } else {
                setErrMsg('Our apologies, but we were not able to change your password.');
            }
            errRef.current.focus();
        }
    }

    return (
        <>
            {success ? (
                <section>
                    <h1>Success!</h1>
                    <p>Your password has been successfully changed.</p>
                    <p><Link to="/">Sign In</Link></p>
                </section>
            ) : (
                <section>
                    <h1>Change Password</h1>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="password">New password:</label>
                        <input
                            type={showPasswords ? "text" : "password"}
                            id="password"
                            className={(validPwd || (pwd === "")) ? "" : "invalid"}
                            onChange={(e) => setPwd(e.target.value)}
                            value={pwd}
                            required
                            aria-invalid={validPwd ? "false" : "true"}
                            aria-describedby="pwdnote"
                            onFocus={() => setPwdFocus(true)}
                            onBlur={() => setPwdFocus(false)}
                        />
                        <p id="pwdnote" className={pwdFocus && !validPwd ? "instructions" : "offscreen"}>
                            8 to 24 characters.<br />
                            Must include uppercase and lowercase letters, a number and a special character.<br />
                            Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span>
                        </p>


                        <label htmlFor="confirm_pwd">Confirm new password:</label>
                        <input
                            type={showPasswords ? "text" : "password"}
                            id="confirm_pwd"
                            className={(validMatch || (matchPwd === "")) ? "" : "invalid"}
                            onChange={(e) => setMatchPwd(e.target.value)}
                            value={matchPwd}
                            required
                            aria-invalid={validMatch ? "false" : "true"}
                            aria-describedby="confirmnote"
                            onFocus={() => setMatchFocus(true)}
                            onBlur={() => setMatchFocus(false)}
                        />
                        <p id="confirmnote" className={matchFocus && !validMatch ? "instructions" : "offscreen"}>
                            Must match the first password
                        </p>

                        <div className="checkbox-and-label" style={{marginTop: '1rem'}}>
                            <input
                                type="checkbox"
                                id="password_visibility"
                                name="password_visibility"
                                value="false"
                                onChange={(e) => setShowPasswords(e.target.checked)}
                            />
                            <label htmlFor="password_visibility">Show passwords</label>
                        </div>                        

                        <button disabled={!validPwd || !validMatch ? true : false}>Change password</button>
                    </form>
                    <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                    <nav>
                        <Link to="/resetpassword">Request password reset link</Link>
                        <Link to="/login">Sign in</Link>
                    </nav>
                </section>
            )}
        </>
    )
}

export default Register